/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Fields, isString, Loading, publish, subscribe, unsubscribe } from '../../../twd/twd'
import useSearchManual from './use-search-manual'
import useMarketNews from '../use-market-news'

var Lock = false
const bounce = (ms=1000) => {
    Lock = true
    setTimeout(() => { Lock = false }, ms)
}


export default ({id}) => {

    const { status, keyword, setKeyword, searchResults, setEntered } = useSearchManual()
    const { customSearch, setCustomSearch } = useMarketNews()

    React.useEffect(() => {
        let subId = subscribe('corporate-market-news-custom-search-entered', (a) => {
            setCustomSearch(a)
        })
        return () => unsubscribe(subId)
    }, [])

    const resetField = () => {
        setKeyword('')
        setCustomSearch('')
    }

    React.useEffect(() => {
        let subId = subscribe('corporates-market-news-custom-search-changed', (field) => {
            if (field!=='sector') return
            resetField()
        })
        return () => unsubscribe(subId)
    }, [])

    return <Fields.Search
        id={id}
        dataName="corporates-market-news-custom-search-company"
        multiple={false}
        value={(customSearch && customSearch.name) || keyword}

        onSelect={(a) => {
            if (isString(a)) {
                setCustomSearch(undefined)
                setEntered(true)
            } else {
                bounce()
                setCustomSearch(a)
            }
        }}

        onBlur={(a) => {
            if (Lock) return

            let {keyword} = a || {}
            if (keyword) {
                setCustomSearch(undefined)
                setEntered(true)
            } else {
                resetField()
            }
        }}

        onClear={() => {
            resetField()
        }}

        onChange={(a) => {
            publish('corporates-market-news-custom-search-changed', 'custom', keyword)
        }}
    >
    {({keyword : text}) => {
        setKeyword(text)

        return <Loading status={status} spinner={false}>
        {
            searchResults.map((r, i) =>
                <Fields.SearchOption
                    dataName="corporates-market-news-custom-search-company"
                    key={i}
                    item={r}>{r.name}</Fields.SearchOption>
            )

        }
        </Loading>
    }}
    </Fields.Search>
}
